import { FirebaseOptions, initializeApp } from 'firebase/app';
import { connectAuthEmulator, getAuth } from 'firebase/auth';

const firebaseConfig: FirebaseOptions = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
};

const app = initializeApp(firebaseConfig);

export const firebaseAuth = getAuth(app);

if (
  process.env.REACT_APP_FIREBASE_VERIFICATION_DISABLED_FOR_TESTING === 'true'
) {
  /**
   * With this on, we won't get the recaptcha if we try to login using a fake number
   * set in the Firebase console. This speeds up testing and allows for E2E tests to
   * run in real environments. Note that this will break the recaptcha for real numbers.
   */
  firebaseAuth.settings.appVerificationDisabledForTesting = true;
}

const FIREBASE_AUTH_EMULATOR_HOST =
  process.env.REACT_APP_FIREBASE_AUTH_EMULATOR_HOST;
if (FIREBASE_AUTH_EMULATOR_HOST) {
  connectAuthEmulator(firebaseAuth, FIREBASE_AUTH_EMULATOR_HOST);
}
